<div class="flex text-center mb-8 bg-white">
  <div class="stat-block flex-1" [class.active]="activeFilter === null && !hasOtherFiltersActive" (click)="filterChange.emit(null)">
    <nz-statistic [nzValue]="(total | number)!" nzTitle="Total"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'sent'" (click)="filterChange.emit('sent')">
    <nz-statistic [nzValue]="(totalSent | number)!" nzTitle="Sent"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'delivered'" (click)="filterChange.emit('delivered')">
    <nz-statistic [nzValue]="(totalDelivered | number)!" nzTitle="Delivered"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'read'" (click)="filterChange.emit('read')">
    <nz-statistic [nzValue]="(totalRead | number)!" nzTitle="Read"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'acknowledged'" (click)="filterChange.emit('acknowledged')">
    <nz-statistic [nzValue]="(totalAcknowledge | number)!" nzTitle="Acknowledged"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'skip'" (click)="filterChange.emit('skip')">
    <nz-statistic [nzValue]="(totalSkip | number)!" nzTitle="Skip"></nz-statistic>
  </div>
  <div class="stat-block flex-1" [class.active]="activeFilter === 'failed'" (click)="filterChange.emit('failed')">
    <nz-statistic [nzValue]="(totalFailed | number)!" nzTitle="Failed"></nz-statistic>
  </div>
</div>
